import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const resultAttributes = [
  'url',
  'tid',
  'name',
  'post_count',
  'comment_count',
  'latest_comment_timestamp',
];

export const sorting: Exclude<SearchkitWrapperProps['searchSettings']['sorting'], undefined> = {
  default: {
    field: 'latest_comment_timestamp',
    order: 'desc',
  },
};
